export default "__VITE_ASSET__9ea9eb3b__"